import { resize } from '../directives';

export default {
    name: "Resize",
    props: {
        mark: {
            type: Object,
            required: true
        },
        layoutMan: {
            type: Object,
            required: true
        }
    },
    directives: { resize },
    render(h) {
        
        const _directionResizable = [
            <div v-resize_top={this.layoutMan} class="cmn-grid-resizable resizable-n" />,
            <div v-resize_right={this.layoutMan} class="cmn-grid-resizable resizable-e" />,
            <div v-resize_bottom={this.layoutMan} class="cmn-grid-resizable resizable-s" />,
            <div v-resize_left={this.layoutMan} class="cmn-grid-resizable resizable-w" />,
            <div v-resize_top_left={this.layoutMan} class="cmn-grid-resizable resizable-n_w" />,
            <div v-resize_top_right={this.layoutMan} class="cmn-grid-resizable resizable-n_e" />,
            <div v-resize_bottom_left={this.layoutMan} class="cmn-grid-resizable resizable-s_w" />,
            <div v-resize_bottom_right={this.layoutMan} class="cmn-grid-resizable resizable-s_e" />
        ];

        _directionResizable.forEach(vnode => {

            const _directive = (vnode.data?.directives || []).find(dir => dir.name === 'resize');

            if (_directive) {
                _directive.argument = this.mark.ID;
            }

        });

        return (
            <div class="cmn-grid-resizable-wrapper">
                {_directionResizable}
            </div>
        );
    }
};